import React from 'react';

function StatCard({ label, value, hint, tone = 'default', compact = false }) {
  const toneModifier = tone !== 'default' ? ` ahri-dash-stat--${tone}` : '';
  const valueTone = tone !== 'default' ? ` ahri-dash-stat__value--${tone}` : '';

  return (
    <div className={compact ? 'col-6 col-lg-4 col-xl-3' : 'col-6 col-md-4 col-xl-3'}>
      <div className={`ahri-dash-stat${toneModifier}`}>
        <div className="ahri-dash-stat__label">{label}</div>
        <div className={`ahri-dash-stat__value${valueTone}`}>{value}</div>
        {hint != null && hint !== '' ? (
          <div className="ahri-dash-stat__hint">{hint}</div>
        ) : null}
      </div>
    </div>
  );
}

export default StatCard;
